/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-08 16:42:32
 */
//复制
import { getSourceUrl } from '@/api/shopManage';
import { linkStatus, PLATFORM_KS } from '@/utils/dataMap';
import { endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek, subDays, subMonths, subWeeks } from 'date-fns';
import store from '@/store';
import * as types from '@/store/mutation-types.js';
import { primaryColor } from '@/styles/colorJs.less';

export const copyFun = async (row, self, state) => {
	let value = '';
	if (+row.platform_id === +PLATFORM_KS.value) {
		copy(row.third_product_id);
		self.$message.success('复制成功');
		return;
	}
	if (state && row.url_check_status && row.url_check_status === linkStatus.finished) {
		value = row.partner_url;
		if (!value) {
			return;
		}
		SourceUrl(row, self);
		// 保持不变
	} else if (self.isDarenPartner) {
		SourceUrl(row, self);
		// 保持不变
	} else {
		copy(row.product_url || row.detail_url);
		self.$message.success('复制成功');
	}
};

async function SourceUrl({ product_id, cooperate_id }, self) {
	const { code, data } = await getSourceUrl({ product_id, cooperate_id });
	if (code === 0) {
		let pick_source = data.pick_source;
		copy(pick_source);
		self.$message.success('复制成功');
	}
}
export const copy = value => {
	setTimeout(() => {
		var inputTest = document.createElement('textarea');
		inputTest.value = value;
		document.body.appendChild(inputTest);
		inputTest.select();
		document.execCommand('Copy');
		inputTest.className = 'oInput';
		inputTest.style.display = 'none';
		document.body.removeChild(inputTest);
	}, 0);
};

export const setIcoAndTitle = (ico, title) => {
	var link = document.createElement('link');
	link.type = 'image/x-icon';
	link.rel = 'shortcut icon';
	link.href = ico;
	document.getElementsByTagName('head')[0].appendChild(link);
	document.title = title;
};

export const getDomain = (isApiDomain = true) => {
	let domain;
	if (isApiDomain) {
		let temp = location.hostname.split('.').reverse();
		domain = '.' + temp[1] + '.' + temp[0];
		// location.hostname == 'dev-part.modengyin.net.cn' 这种格式, 再取前一级。
		if (['net', 'cn', 'com'].indexOf(temp[1]) > -1) {
			domain = '.' + temp[2] + domain;
		}
		// 为了兼容二级域名，后端接口固定访问chaoyongtuan.com
		let defaultDomain = ['.vipsaas.com', '.hongrenxingxuan.com']; //默认走超佣团配置接口
		if (defaultDomain.includes(domain)) {
			domain = '.chaoyongtuan.com';
		}
	} else {
		let temp = location.hostname.split('.').reverse();
		domain = '.' + temp[1] + '.' + temp[0];
		// location.hostname == 'dev-part.modengyin.net.cn' 这种格式, 再取前一级。
		if (['net', 'cn', 'com'].indexOf(temp[1]) > -1) {
			domain = '.' + temp[2] + domain;
		}
	}
	return domain;
};
export const getJAVADomain = () => {
	let domain;
	let temp = location.hostname.split('.').reverse();
	domain = '.' + temp[1] + '.' + temp[0];
	// location.hostname == 'dev-part.modengyin.net.cn' 这种格式, 再取前一级。
	if (['net', 'cn', 'com'].indexOf(temp[1]) > -1) {
		domain = '.' + temp[2] + domain;
	}
	// 二级域名或超佣团域名，java后端接口固定访问supsaas.com
	let defaultDomain = ['.vipsaas.com', '.chaoyongtuan.com', '.hongrenxingxuan.com']; //默认走超佣团配置接口
	if (defaultDomain.includes(domain)) {
		domain = '.supsaas.com';
	}
	return domain;
};
export const apiBaseUrl = (isJava = false) => {
	return (isJava ? process.env.VUE_APP_JAVA_API_BASE + getJAVADomain() : process.env.VUE_APP_API_BASE + getDomain()) + '/';
};

export const wechatQrUrl = share_id => {
	return apiBaseUrl() + '/api/wechat/qr?share_code=' + share_id;
};

//一键复制
export const clipboard = e => {
	return new Promise(function (t, n) {
		var r = document;
		if (r.body.createTextRange) {
			var o = document.body.createTextRange();
			o.moveToElementText(e), o.select();
		} else if (window.getSelection) {
			var a = window.getSelection(),
				i = document.createRange();
			i.selectNodeContents(e), a.removeAllRanges(), a.addRange(i);
		}
		document.execCommand('copy'), window.getSelection().removeAllRanges(), t(!0);
	});
};

export const gen_text_img = (size, s) => {
	let colors = ['rgb(255, 236, 235)'];
	let cvs = document.createElement('canvas');
	cvs.setAttribute('width', size[0]);
	cvs.setAttribute('height', size[1]);
	let ctx = cvs.getContext('2d');
	ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
	ctx.fillRect(0, 0, size[0], size[1]);
	ctx.fillStyle = 'rgb(250, 45, 72)';
	ctx.font = size[0] * 0.6 + 'px Arial';
	ctx.textBaseline = 'middle';
	ctx.textAlign = 'center';
	ctx.fillText(s, size[0] / 2, size[1] / 2);

	return cvs.toDataURL('image/jpeg', 1);
};

export const calDate = value => {
	const toDay = new Date();
	const yesterDay = subDays(toDay, 1);
	const start_time = startOfDay(value ? subDays(yesterDay, value - 1) : toDay);
	let end_time = endOfDay(value ? yesterDay : toDay);
	return [start_time, end_time];
};
// startEndTime转day
export const calculateDays = dateRange => {
	const [start_time, end_time] = dateRange;
	const today = new Date();
	// 将时间戳转换为毫秒数
	const startTimeInMs = start_time.getTime() / 1000;
	const endTimeInMs = end_time.getTime() / 1000;
	// 计算两个时间之间的秒数差异
	const timeDifferenceInMs = endTimeInMs - startTimeInMs;
	// 将毫秒数转换为天数
	const daysDifference = timeDifferenceInMs / (60 * 60 * 24);
	const weekStartOptions = { weekStartsOn: 1 };
	// 判断时间范围是否是上一周的范围
	const isLastWeek =
		startTimeInMs === Math.trunc(startOfWeek(subWeeks(today, 1), weekStartOptions).valueOf() / 1000) &&
		endTimeInMs === Math.trunc(endOfWeek(subWeeks(today, 1), weekStartOptions).valueOf() / 1000);
	// 判断时间范围是否是本周的范围
	const isThisWeek =
		startTimeInMs === Math.trunc(startOfWeek(today, weekStartOptions).valueOf() / 1000) &&
		endTimeInMs === Math.trunc(endOfDay(subDays(today, 1)).valueOf() / 1000);
	// 判断时间范围是否是上个月的范围
	const isLastMonth =
		startTimeInMs === Math.trunc(startOfMonth(subMonths(today, 1)).valueOf() / 1000) &&
		endTimeInMs === Math.trunc(endOfMonth(subMonths(today, 1)).valueOf() / 1000);
	// 判断时间范围是否是本月的范围
	const isThisMonth =
		startTimeInMs === Math.trunc(startOfMonth(today).valueOf() / 1000) && endTimeInMs === Math.trunc(endOfDay(subDays(today, 1)).valueOf() / 1000);
	if (isThisWeek || isLastWeek) {
		return 'week';
	} else if (isThisMonth || isLastMonth) {
		return 'month';
	} else {
		// 如果不是完整的周或月，返回天数
		return Math.floor(daysDifference + 1);
	}
};

/**
 * @description: 数据类型判断
 * @param {*} data 需要判断的原数据
 * @param {*} dataType 需要判断的数据类型
 * @return {*} 传递dataType用于判断当前数据的类型是否与传入值相等，不传递则返回当前数据的数据类型
 * @acthor: Li Yong
 * @Date: 2022-10-10 15:33:29
 */
export const checkIsType = (data, dataType) => {
	const toString = Object.prototype.toString;
	const _dataType =
		data instanceof Element
			? 'element'
			: toString
					.call(data)
					.replace(/\[object\s(.+)\]/, '$1')
					.toLowerCase();
	return dataType ? _dataType === dataType.toLowerCase() : _dataType;
};
// yyyy-MM-dd格式
export const formatterDate = value => {
	let dateArr = [];
	calDate(value).forEach(item => {
		var date = new Date(item);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = Number(m) < 10 ? '0' + m : m;
		var d = date.getDate();
		d = Number(d) < 10 ? '0' + d : d;
		dateArr.push(y + '-' + m + '-' + d);
	});
	return dateArr;
};

export const disabledDate = (time, showDays, containtToday = false) => {
	const toDay = new Date();
	const yesterDay = subDays(toDay, 1);
	const endDay = containtToday ? toDay : yesterDay;
	const hasShowDays = showDays !== undefined;
	const subDay = hasShowDays ? (containtToday ? showDays : showDays - 1) : '';
	return time.getTime() > endOfDay(endDay) || (hasShowDays && time.getTime() < startOfDay(subDays(endDay, subDay)).getTime());
};

export const handLink = link => {
	var a = document.createElement('a');
	a.setAttribute('href', link);
	a.setAttribute('target', '_blank');
	a.setAttribute('id', 'startTelMedicine');
	// 防止反复添加
	if (document.getElementById('startTelMedicine')) {
		document.body.removeChild(document.getElementById('startTelMedicine'));
	}
	document.body.appendChild(a);
	a.click();
};

//数组降序
export const arrSort = (arr, property) => {
	return arr.sort(function (a, b) {
		var value1 = a[property];
		var value2 = b[property];
		return value2 - value1;
	});
};
//将下划线换为驼峰
export const replaceUnderLine = (val, char = '_') => {
	const arr = val.split(char);
	const arrs = arr.map((item, index) => {
		if (index) {
			item = item.replace(RegExp(`${item[0]}`, 'i'), item[0].toUpperCase());
		}
		return item;
	});
	val = arrs.join('');
	return val;
};
export const initQueryParams = (formData, query, options) => {
	const { matches } = options;
	if (matches?.length) {
		matches.forEach(match => {
			if (typeof match == 'string') {
				formData[match] = query[match];
				return;
			}
			const { key: formKey, queryKey, format, defaultValue } = match;
			formData[formKey] = format ? format(query[queryKey]) : query[queryKey] || defaultValue;
		});
		return;
	}
	const keys = Object.keys(query);
	keys.forEach(key => (formData[key] = query[key]));
};
//下划线转驼峰
export const filterUnderLine = (obj, char = '_') => {
	const arr = Object.keys(obj).filter(item => item.indexOf(char) !== -1);
	arr.forEach(item => {
		const before = obj[item];
		const key = replaceUnderLine(item);
		obj[key] = before;
		delete obj[item];
	});
	return obj;
};

// 字符串转驼峰
export const toCamelCase = str => str.replace(/([A-Z])/g, '_$1').toLowerCase();
// 字符串转下划线
export const toDownLineCase = str => str.replace(/_(\w)/g, x => x.slice(1).toUpperCase());
/**
 * @description: 深拷贝对象，支持将对象的key值格式化
 * @param {Object} obj 需要拷贝的对象
 * @param {String} type 拷贝后对象的key值的格式化类型，可选camel(驼峰), downLine(下划线)
 * @return {Object} 深拷贝之后的对象
 * @acthor: Li Yong
 * @Date: 2022-08-22 20:46:47
 */
export const deepClone = (obj, type = 'nonedeepClone') => {
	var objClone = Array.isArray(obj) ? [] : {};
	if (obj && typeof obj === 'object') {
		for (const key in obj) {
			if (Object.hasOwnProperty.call(obj, key)) {
				const _key = type === 'camel' ? toCamelCase(key) : type === 'downLine' ? toDownLineCase(key) : key;
				if (obj[key] && typeof obj[key] === 'object') {
					objClone[_key] = deepClone(obj[key], type);
				} else {
					objClone[_key] = obj[key];
				}
			}
		}
	}
	return objClone;
};
/**
 * @description: 判断左右两个数字是否相等，用于解决后端数据类型不一致的问题，仅适用于number和string的判断
 * @param {number|string} left
 * @param {number|string} right
 * @return {boolean} 是否一致
 * @acthor: Li Yong
 * @Date: 2022-11-02 17:11:04
 */
export const isEqual = (left, right) => {
	return +left === +right;
};
// 十六进制改为rgba
function hexToRgba(color, opacity) {
	const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 把颜色值变成小写
	if (reg.test(color)) {
		// 如果只有三位的值，需变成六位，如：#fff => #ffffff
		if (color.length === 4) {
			let colorNew = '#';
			for (let i = 1; Number(i) < 4; i += 1) {
				colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
			}
			color = colorNew;
		}
		// 处理六位的颜色值，转为RGB
		const colorChange = [];
		for (let i = 1; Number(i) < 7; i += 2) {
			colorChange.push(parseInt('0x' + color.slice(i, i + 2)));
		}
		return 'rgba(' + colorChange.join(',') + ',' + opacity + ')';
	} else {
		return color;
	}
}
/**
 * @description: 生成图表中需要的阶梯颜色，以主题色为主色，阶梯公式90 - 60/n
 * @param {*} splitNo 阶梯数，最小为1，最大为9
 * @param {*} colorInd 当前的阶梯值，最小为0
 * @return {*}
 * @acthor: Li Yong
 * @Date: 2023-06-07 15:55:47
 */
export const generateChartsColor = (splitNo, colorInd) => {
	if (!/^[1-9]$/g.test(splitNo)) {
		new Error('阶梯数只能为1-9的整数');
	}
	// 最大透明度值
	const maxOpacity = 90;
	// 主色
	const mainColor = primaryColor;
	// 阶梯透明度间隔
	const opacityGap = 60 / splitNo;
	// 阶梯透明度数组
	const opacitys = new Array(splitNo).fill(1).map((_, index) => maxOpacity - opacityGap * index);
	// 阶梯颜色数组
	const rgbaColors = opacitys.map(item => hexToRgba(mainColor, item / 100));
	// 默认返回整个颜色数组
	if (colorInd === void 0) {
		return rgbaColors;
	}
	// 当前阶梯值大于等于最大阶梯数则取第一个颜色
	const _index = Number(colorInd) < Number(splitNo) ? colorInd : 0;
	return rgbaColors[_index];
};
//时间戳转时间
export const toDates = times => {
	const date = new Date(times);
	const Y = date.getFullYear();
	const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	const H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
	const Min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	const S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	const dateTime = Y + '/' + M + '/' + D + '     ' + H + ':' + Min + ':' + S;
	return dateTime;
};
/**
 * @description: 清除cookie，localStorage，vuex中存储的所有数据
 * @return {*}
 * @acthor: Li Yong
 * @Date: 2022-09-06 16:53:55
 */
export const clearData = () => {
	CookiesTools.removeToken();
	store.commit(types.LOGIN_STATUS, false);
	store.commit(types.PAGE_LOADING, null);
	store.commit(types.MEUNS_LIST, []);
	store.commit(types.USER_ID, '');
	store.commit(types.USER_INFO, {});
	store.commit(types.TEAM_CONFIG, {});
	store.commit(types.TENANT_ID, '');
	store.commit(types.BIND_ROLES, []);
	store.commit(types.DATA_VIEW_ID, '');
	store.commit(types.SPH_EXPO_NAME, '');
	store.commit(types.KS_CATEGORY, []);
	store.commit(types.DY_CATEGORY, []);
	store.commit(types.SET_PLATFORM, '');
	store.commit(types.USER_TYPE_LIST, []);
	store.commit(types.DATA_VIEW_LIST, []);
	store.commit(types.INVITE_DATA, {});
};

//数组排序
export const arrSortByProperty = (arr, property, type = 'desc') => {
	return arr.sort(function (a, b) {
		var value1 = a[property];
		var value2 = b[property];
		return type === 'asc' ? value1 - value2 : value2 - value1;
	});
};

export default {
	clearData,
	arrSortByProperty,
	generateChartsColor,
	checkIsType,
	copy,
	initQueryParams,
	filterUnderLine,
};
/**
 * 是否为函数
 * @param {} fn
 * @returns boolean
 */
export const isFunction = fn => {
	return Object.prototype.toString.call(fn) === '[object Function]';
};
